/*
The process.env was defined at webpack.config.js.
	plugins: [
		new webpack.DefinePlugin({
			'process.env': { ... }
		}),
	]
 */
export default process.env;
